import React from 'react'

const TestGround = (
    number: number
) => {
    return (
        <>
            <div>TestGround tsx</div>
        </>
    )
}

export default TestGround